import { captureException } from '@playbookux/playbook-web-core';
import client from './client';

export const initializeUpload = (sessionId, replace = false) => client
  .post(`/test_sessions/${sessionId}/create_video`, { replace })
  .then((response) => response.data).catch((error) => captureException('INITIALIZE_UPLOAD_FAILED', error));

export const uploadPart = (sessionId, uploadId, partNumber, part, onUploadProgress, replace = false) => {
  const formData = new FormData();

  formData.set('upload_id', uploadId);
  formData.set('part_number', partNumber);
  formData.set('part', part);
  formData.set('replace', replace);

  return client
    .post(`/test_sessions/${sessionId}/video_part`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress,
    })
    .then((response) => response.data).catch((err) => captureException('VIDEO_UPLOAD_PART_FAILED', err));
};

export const completeUpload = async (sessionId, uploadId, parts, replace = false) => client
  .post(`/test_sessions/${sessionId}/complete_video`, {
    upload_id: uploadId,
    parts,
    replace,
  });

export const abortUpload = (sessionId, uploadId, replace = false) => client
  .post(`/test_sessions/${sessionId}/abort_video`, {
    upload_id: uploadId,
    replace,
  })
  .then((response) => response.data).catch((error) => captureException('ABORT_UPLOAD_FAILED', error));
